<section>
  <div class="container-fluid mt-2">
    <div *ngIf="flashCardList?.length" class="row border">
      <div class="col-md-12">
        <table
          class="table table-bordered table-hover table-responsive"
          style="
            position: relative;
            height: 75vh;
            display: inline-block;
            overflow-y: scroll;
            width: 100%;
          "
          id="example"
          class="display"
        >
          <thead style="position: sticky; top: 0; background-color: #f1f1f1">
            <tr class="table-active Page-Header">
              <th scope="col" style="width: 10%">
                <div class="d-flex justify-content-center">
                  <b>Flash Card No.</b>
                </div>
              </th>
              <th scope="col" style="width: 40%">
                <div class="d-flex justify-content-center">
                  <b>Subject Name</b>
                </div>
              </th>
              <th scope="col" style="width: 10%">
                <div class="d-flex justify-content-center">
                  <b>Difficulty Level</b>
                </div>
              </th>
              <th scope="col" style="width: 10%">
                <div class="d-flex justify-content-center">
                  <b>Language Type</b>
                </div>
              </th>
              <th scope="col" style="width: 10%">
                <div class="d-flex justify-content-center">
                  <b>Status</b>
                </div>
              </th>
              <th
                scope="col"
                id="fst"
                (click)="stopProp($event)"
                style="width: 100%"
              >
                <div
                  class="d-flex justify-content-center"
                  (click)="stopProp($event)"
                >
                  <b (click)="stopProp($event)">Front View</b>
                </div>
              </th>
              <!-- <th scope="col" id="bst">
                <div class="d-flex justify-content-center">
                  <b>Back Side</b>
                </div>
              </th> -->
              <th scope="col" style="width: 20%">
                <div class="d-flex justify-content-center">
                  <b>Created By</b>
                </div>
              </th>
              <th scope="col" style="width: 20%">
                <div class="d-flex justify-content-center">
                  <b>Created Date</b>
                </div>
              </th>
              <th scope="col" style="width: 20%">
                <div class="d-flex justify-content-center">
                  <b>Updated By</b>
                </div>
              </th>
              <th scope="col" style="width: 20%">
                <div class="d-flex justify-content-center">
                  <b>Updated Date</b>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let flashCard of flashCardList; let i = index"
              (click)="openFlashcard(flashCard)"
            >
              <td>
                <div>
                  <span
                    ><a class="link" style="cursor: pointer">
                      {{ flashCard.FlashCard_ID }}
                    </a></span
                  >
                </div>
              </td>
              <td>
                <div>{{ flashCard.Subject_Name }}</div>
              </td>
              <td>
                <div>{{ flashCard.Concept_Difficulty_Level_Type_Name }}</div>
              </td>
              <td>
                <div>{{ flashCard.Language_Type_Name }}</div>
              </td>
              <td>
                <div>{{ flashCard.Flashcard_Status_Type_Name }}</div>
              </td>
              <td>
                <div
                  class="ellipsis"
                  style="width: 25em; height: 5em; overflow: scroll"
                  [innerHTML]="flashCard.Front_Side_Text"
                ></div>
              </td>
              <!-- <td>
                <div
                  class="ellipsis"
                  style="width: 25em; height: 5em; overflow: scroll"
                  [innerHTML]="flashCard.Back_Side_Text"
                ></div>
              </td> -->
              <td>
                <div>{{ flashCard.Created_By }}</div>
              </td>
              <td>
                <div>{{ flashCard.Creation_Date | date }}</div>
              </td>
              <td>
                <div>{{ flashCard.Updated_By }}</div>
              </td>
              <td>
                <div>{{ flashCard.Updation_Date | date }}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row" *ngIf="!flashCardList?.length">
      <div class="col-md-12 d-flex justify-content-center mt-2">No Content</div>
    </div>
  </div>
</section>
